export enum Platform {
  Web = "Web",
  MobileNative = "Mobile",
}
